import { useEffect, useRef } from 'react'
import { isEmpty } from 'lodash'
import cn from 'classnames'
import ReactModal from 'react-modal'

import { ReactComponent as CloseIcon } from 'assets/icons/IconClose.svg'

type TProps = {
  title: string
  onClose: () => void
  className?: string
  children?: React.ReactNode
  subtitle?: string
}

const Modal = ({ title, subtitle, onClose, children, className }: TProps) => {
  const modalRef = useRef(null)

  useEffect(() => {
    return () => {
      document.body.classList.remove('ReactModal__Body--open')
    }
  }, [])

  return (
    <ReactModal
      isOpen
      className={cn('modal', className)}
      overlayClassName="modal-overlay"
      appElement={document.getElementById('root') as HTMLElement}
    >
      <div className="modal-header" ref={modalRef}>
        <div className="header-row">
          <h1>{title}</h1>
          <button className="close-icon" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        {!isEmpty(subtitle) && (
          <div className="header-row">
            <h2>{subtitle}</h2>
          </div>
        )}
      </div>
      {children}
    </ReactModal>
  )
}

export default Modal
